let routes = [
  {
    path: "/payer-une-facture/:idFacture",
    component: () => import("../views/Factures/Facture.vue"),
  },
]

export default routes
